export default __webpack_public_path__ + "static/media/org-work-mark.c641eb4a.svg";